import {
  faAnalytics,
  faArrowAltCircleDown,
  faBoxesStacked,
  faBuilding,
  faCartShopping,
  faCheckCircle as faCheckCircleLight,
  faClipboardListCheck,
  faClock,
  faCommentDots,
  faCommentsDollar,
  faCopy,
  faDesktop,
  faDoorClosed,
  faEnvelope as faEnvelopeLight,
  faEnvelopeOpen,
  faEnvelopeOpenText as faEnvelopeOpenTextLight,
  faFileInvoiceDollar,
  faFolderPlus,
  faGrid2,
  faMagic,
  faMapMarkerAlt,
  faMinimize,
  faPaperclip as faPaperclipLight,
  faPen as faPenLight,
  faPhone,
  faPhoneAlt,
  faPhoneOffice,
  faQuestion as faQuestionLight,
  faShapes,
  faSignal,
  faSmile as faSmileLight,
  faSync as faSyncLight,
  faTimes as faTimesLight,
  faUserCog,
  faUserFriends,
  faUserPlus,
  faUsers,
  faWalking,
} from '@fortawesome/pro-light-svg-icons';

const proLightSvgIcons = {
  analyticsLight: faAnalytics,
  boxesStackedLight: faBoxesStacked,
  buildingLight: faBuilding,
  checkCircleLight: faCheckCircleLight,
  clipboardList: faClipboardListCheck,
  clockLight: faClock,
  closeLight: faTimesLight,
  commentsDollar: faCommentsDollar,
  copyLight: faCopy,
  desktopComputer: faDesktop,
  doorClosed: faDoorClosed,
  envelopeOpenLight: faEnvelopeOpen,
  smileLight: faSmileLight,
  fileInvoiceDollar: faFileInvoiceDollar,
  folderPlus: faFolderPlus,
  grid2Light: faGrid2,
  magic: faMagic,
  mailLight: faEnvelopeLight,
  mailOpenTextLight: faEnvelopeOpenTextLight,
  mapAltLight: faMapMarkerAlt,
  paperclip: faPaperclipLight,
  penLight: faPenLight,
  phoneAltLight: faPhoneAlt,
  phoneLight: faPhone, // Since the alt phone is already exported without prefix for regular and solid, we will add it in light as well for consistency
  questionLight: faQuestionLight,
  refreshLight: faSyncLight,
  scoreDown: faArrowAltCircleDown,
  shapesLight: faShapes,
  signal: faSignal,
  smsLight: faCommentDots,
  teamLight: faUsers,
  telephoneLight: faPhoneOffice,
  userCog: faUserCog,
  userPlus: faUserPlus,
  usersLight: faUserFriends,
  walking: faWalking,
  shoppingCart: faCartShopping,
  minimizeScreenLight: faMinimize,
};

export { proLightSvgIcons };
